import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdBanner } from '../models/ads-banner-data.model';
import { environment } from '@nrwl/environment';

@Injectable({
  providedIn: 'root',
})
export class AdsBannerDataService {
  private apiUrl: string = environment.adsBannerData;

  constructor(private http: HttpClient) {}

  getAdsBannerData(): Observable<AdBanner[]> {
    return this.http.get<AdBanner[]>(this.apiUrl);
  }
}
